module.exports = __webpack_public_path__ + "img/Birthday.2fbe50a0.png";